export default "__VITE_ASSET__BVjykXWR__"